import { normalize } from 'normalizr';

import type { PrintPageViewerData } from '@frontend/api';

import type { RawViewerPartFile, ViewerPartFile } from '../types';
import { partFileSchema, printPageSchema } from './entities';

export const types = {
  RECEIVE_ACTIVE_PART_FILE_UUID: 'common/viewer/RECEIVE_ACTIVE_PART_FILE_UUID',
  RECEIVE_PAGE_VECTORIZATION: 'common/viewer/RECEIVE_PAGE_VECTORIZATION',
  RECEIVE_PART_FILE: 'common/viewer/RECEIVE_PART_FILE',
  RECEIVE_PRINT_PAGE: 'common/viewer/RECEIVE_PRINT_PAGE',
  RECEIVE_PART_FILES: 'common/viewer/RECEIVE_PART_FILES',
  RESET: 'common/viewer/RESET',
} as const;

export const viewer = {
  receiveActivePartFileUuid: ({
    partFileUuid,
    shouldFocus,
    shouldPropagateVisibility,
    ignoreQueue,
  }: {
    partFileUuid: string;
    shouldFocus: boolean;
    shouldPropagateVisibility: boolean;
    ignoreQueue?: boolean;
  }) => ({
    type: types.RECEIVE_ACTIVE_PART_FILE_UUID,
    payload: {
      partFileUuid,
      shouldFocus,
      shouldPropagateVisibility,
      ignoreQueue,
    },
  }),
  receivePageVectorization: ({
    pageIdToVectorization,
  }: {
    pageIdToVectorization: Record<string, unknown>;
  }) => ({
    type: types.RECEIVE_PAGE_VECTORIZATION,
    payload: { pageIdToVectorization },
  }),
  receivePartFiles: ({ partFiles }: { partFiles: RawViewerPartFile[] }) => ({
    type: types.RECEIVE_PART_FILES,
    payload: normalize<ViewerPartFile>(partFiles, [partFileSchema]),
  }),
  receivePartFile: ({ file }: { file: RawViewerPartFile }) => ({
    type: types.RECEIVE_PART_FILE,
    payload: {
      ...normalize<ViewerPartFile>(file, partFileSchema),
    },
  }),
  receivePrintPage: ({ printPage }: { printPage: PrintPageViewerData }) => ({
    type: types.RECEIVE_PRINT_PAGE,
    payload: {
      ...normalize(printPage, printPageSchema),
    },
  }),
  reset: () => ({
    type: types.RESET,
  }),
};
